// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4bdcb660","455":"9bc3183d","977":"3509d537"}[chunkId] + ".chunk.js";
};